import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormArray, FormGroup, UntypedFormGroup } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatRadioChange } from '@angular/material/radio';
import { SharedModule } from '@sbd-account-portal/app/shared/shared.module';
import { SharedComponentsModule } from '@sbd-doug-frontend/shared/lib/shared-components/shared-components.module';
import { businessTypes, CIPXQuoteRequestIntakeForm } from '../../../../intake-form.types';
import { blockNegativeNumberKeys, formatLocalCalendarDate, isCIPXQuoteRequestIntakeFormStateBond, requiresCredit, sectionHasQuestions } from '../../../../intake-form.helpers';
import { CIPXQuoteRequestIntakeFormService } from '../../../../intake-form.service';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {
  MatLuxonDateModule,
  MAT_LUXON_DATE_FORMATS,
} from '@angular/material-luxon-adapter';
import { CIPXQuoteRequestIntakeFormQuestionSetComponent } from '../../../../question-set/question-set.component';

@Component({
  standalone: true,
  imports: [
    SharedModule,
    SharedComponentsModule,
    MatLuxonDateModule,
    MatDatepickerModule,
    MatButtonModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatIconModule,
    CIPXQuoteRequestIntakeFormQuestionSetComponent,
  ],
  providers: [
    MatDatepickerModule,
    {
      provide: MAT_DATE_FORMATS,
      useValue: MAT_LUXON_DATE_FORMATS,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
  ],
  selector: 'cipx-quote-request-intake-form-request-details-bond-information',
  templateUrl: 'bond-information.component.html',
})
export class CIPXQuoteRequestIntakeFormRequestDetailsBondInformationComponent {
  private _intakeFormService = inject(CIPXQuoteRequestIntakeFormService);

  private _changeDetectorRef = inject(ChangeDetectorRef);
  @Input() quoteRequestForm!: FormGroup<CIPXQuoteRequestIntakeForm>;

  sectionHasQuestions = sectionHasQuestions;
  businessTypes = businessTypes;
  blockNegativeNumberKeys = blockNegativeNumberKeys;

  selectedStateBond = this._intakeFormService.selectedStateBond;

  ngOnInit() {}

  get requestDetailsGroup(): FormGroup {
    return this.quoteRequestForm.controls.requestDetails;
  }

  get principal(): FormGroup {
    return this.quoteRequestForm.controls.requestDetails.controls.principal as FormGroup;
  }

  get owners(): FormArray {
    return this.quoteRequestForm.controls.requestDetails.controls.owners as FormArray;
  }

  onFormationDateInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const inputType = (event as InputEvent).inputType ?? '';
    if (inputType.startsWith('delete')) {
      return;
    }

    const digits = input.value.replace(/\D/g, '').slice(0, 6);
    const month = digits.slice(0, 2);
    const formatted = /^(0[1-9]|1[0-2])$/.test(month)
      ? `${month}/${digits.slice(2)}`
      : digits.slice(0, 4);

    if (input.value !== formatted) {
      input.value = formatted;
      this.requestDetailsGroup.controls.company_formation_date.setValue(formatted, { emitEvent: false });
    }
  }

  onCompanyNumberOwnersChange(value: MatButtonToggleChange) {
    this._intakeFormService.companyNumberOwnersChanged.emit(value.value);
  }

  onCompanyTypeIdChanged(value: MatRadioChange) {
    if (value.value === 3) {
      this.quoteRequestForm.controls.requestDetails.controls.company_number_owners.setValue(1);
      this._intakeFormService.companyNumberOwnersChanged.emit(1);
    }

    this._intakeFormService.companyTypeIdChanged.emit(value.value);
  }

  setEffectiveDateToday() {
    this.quoteRequestForm.controls.requested_coverage_begin_date.setValue(formatLocalCalendarDate(new Date()));
  }

  toggleCompanyAddress() {
    const current = this.quoteRequestForm.controls.requestDetails.controls.addCompanyAddress.value;

    if (current === null || current === false) {
      this.quoteRequestForm.controls.requestDetails.controls.addCompanyAddress.setValue(true);
    } else {
      this.quoteRequestForm.controls.requestDetails.controls.addCompanyAddress.setValue(false);
    }
    this._changeDetectorRef.markForCheck();
  }
}
